import { Component, inject, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { CountryService } from '../../services/country.service';
import { GlobalService } from '../../services/global.service';
import { CommonModule } from '@angular/common';
import { AgGridListComponent } from '../../components/ag-grid-list/ag-grid-list.component';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { ButtonComponent } from '../../components/button/button.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { DropdownService } from '../../services/dropdown.service';
import { BarcodeService } from '../../services/barcode.service';
import { ValidationService } from '../../services/validation.service';
import { FormService } from '../../services/form.service';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';

@Component({
  selector: 'app-barcode-mapping',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, SelectInputComponent, DropdownUploadButtonComponent, FilterByKeyAndValuePipe],
  templateUrl: './barcode-mapping.component.html',
  styleUrl: './barcode-mapping.component.css'
})
export class BarcodeMappingComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any

  page_name = 'Barcode Mapping';
  form: FormGroup;
  params: any = {};
  selected_item: any = {}
  items: any = [];
  fs = inject(FormService);
  show_menu = false;

  filteredAcademicYears: any[] = [];
  lastUniversityId: any = null;
  filteredStudentList: any[] = [];
  modalDropdownRegistry: { [depended: number]: any } = {};

  registerModalDropdown(event: { depended: number; ref: any }) {
    this.modalDropdownRegistry[event.depended] = event.ref;
  }

  onModalDropdownChange(event: { value: any, depended: number }) {
    if (event.depended == 1) {
      this.filteredAcademicYears = [];
      this.lastUniversityId = null;
      this.filteredStudentList = [];
      this.form.patchValue({ academic_year_id: null, exam_id: null, subject_id: null, student_id: null }, { emitEvent: false });
    }
    if (event.depended == 2) {
      this.filteredStudentList = [];
      this.form.patchValue({ exam_id: null, subject_id: null, student_id: null }, { emitEvent: false });
    }
    if (event.depended == 3) {
      this.filteredStudentList = [];
      this.form.patchValue({ subject_id: null, student_id: null }, { emitEvent: false });
    }
    if (event.depended == 4) {
      this.filteredStudentList = [];
      this.form.patchValue({ student_id: null }, { emitEvent: false });
      const subject_id = event.value?.value || event.value;
      const exam_id = this.form.get('exam_id')?.value;
      if (subject_id && exam_id) {
        this.ds.get_students_by_subject(subject_id, exam_id).then((list: any[]) => {
          this.filteredStudentList = list;
        });
      }
    }
    const current = event.depended;
    for (const key of Object.keys(this.modalDropdownRegistry).map(Number)) {
      if (key > current) {
        this.modalDropdownRegistry[key]?.reset();
      }
    }
  }

  get_filtered_academic_years(university_id: any) {
    if (!university_id || !this.ds.dropdown_list?.assessment_list) {
      this.filteredAcademicYears = [];
      this.lastUniversityId = null;
      return this.filteredAcademicYears;
    }
    if (university_id === this.lastUniversityId && this.filteredAcademicYears.length > 0) {
      return this.filteredAcademicYears;
    }
    const academic_year_ids = this.ds.dropdown_list.assessment_list
      .filter((a: any) => a.university_id == university_id)
      .map((a: any) => a.academic_year_id)
      .filter((id: any, i: number, self: any[]) => self.indexOf(id) === i);
    this.filteredAcademicYears = this.ds.dropdown_list?.academic_list?.filter((a: any) =>
      academic_year_ids.includes(a.id)
    ) || [];
    this.lastUniversityId = university_id;
    return this.filteredAcademicYears;
  }


  country_cols: any = [
    { headerName: 'Sr.No', field: 'SrNo', },
    // { field: 'name', headerName: 'Name', filter: true, flex: 1, min_length: 2, min_length_error: "Minimum 2 characters are required Name", },
    { field: 'Exam.name', headerName: 'Exam', filter: true, flex: 1 },
    { field: 'Subject.name', headerName: 'Subject', filter: true, flex: 1, min_length: 2, min_length_error: "Minimum 2 characters are required Name", },
    { field: 'resolved_roll_number', headerName: 'Roll No', filter: true, flex: 1 },
    { field: 'barcode', headerName: 'Barcode', filter: true, flex: 1, min_length: 2, min_length_error: "Minimum 2 characters are required Name", },
    // { field: 'is_active', headerName: 'Status', filter: true, flex: 1, valueGetter: (params: any) => params.data?.is_active, cellRenderer: (params: any) => { return params.value ? 'Enable' : 'Disable'; } },
    { headerName: "Actions", sortable: false, filter: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 130, minWidth: 130, maxWidth: 130 }
  ];

  bulk_columns = [
    { column_name: 'School', type: 'link', linked_list: 'university_list', returning_key: 'id', return_as: 'university_id', sample_value: 'ABC School' },
    { column_name: 'Academic Year', type: 'link', linked_list: 'academic_list', returning_key: 'id', return_as: 'academic_year_id', sample_value: '2026-2027' },
    { column_name: 'Exam', type: 'link', linked_list: 'exam_list', returning_key: 'id', return_as: 'exam_id', sample_value: 'DBMS' },
    { column_name: 'Subject', type: 'link', linked_list: 'subject_list', returning_key: 'id', return_as: 'subject_id', sample_value: 'DBMS' },
    { column_name: 'Roll No', type: 'link', linked_list: 'student_list', returning_key: 'user_id', return_as: 'student_id', sample_value: '2021001' },
    { column_name: 'Barcode', type: 'text', return_as: 'barcode', sample_value: 'BC12345' },
    // { column_name: 'Status', type: 'text', return_as: 'is_active', sample_value: true },
  ];

  bulk_columns_download = [
    { column_name: 'Exam', download_bind: 'exam_id', type: 'link', linked_list: 'exam_list', linked_from: 'exam', return_as: 'exam_id', sample_value: 'AD' },
    { column_name: 'Subject', download_bind: 'subject_id', type: 'link', linked_list: 'subject_list', linked_from: 'subject', return_as: 'subject_id', sample_value: 'AD' },
    { column_name: 'Roll No', download_bind: 'student_id', type: 'link', linked_list: 'student_list', linked_from: 'student', return_as: 'student_id', sample_value: 'AD' },
    { column_name: 'Barcode', type: 'text', return_as: 'barcode', sample_value: '111' },
  ]

  actions(row: any) {
    let actions: any = []
    // actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this) })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.script_management_barcode_mapping_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this), permissions: this.gs.user_role_data?.script_management_barcode_mapping_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public bcs: BarcodeService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      university_id: [''],
      academic_year_id: [''],
      exam_id: ['', [Validators.required]],
      subject_id: ['', [Validators.required]],
      student_id: ['', [Validators.required]],
      // name: ['', [Validators.required]],
      barcode: ['', [Validators.required, Validators.pattern(this.vs.name_pattern)]],
      is_active: [true]
    });
  }

  async ngOnInit() {
    await this.ds?.get_dropdown_list(['academic-year', 'university', 'exam', 'subject', 'student', 'student_data', 'assessment', 'assess']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      // await this.get_list(this.params);
    })

  }
  async get_list(filter?: any) {
    try {
      if (!this.ds.dropdown_list?.student_list?.length) {
        await this.ds.get_dropdown_list(['student']);
      }
      const res = await this.bcs.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => {
        const student = (this.ds.dropdown_list?.student_list || []).find((s: any) => s.id == item.student_id);
        const mapping = (student?.StudentMappings || []).find((m: any) =>
          m.exam_id == item.exam_id && Array.isArray(m.subject_ids) && m.subject_ids.includes(+item.subject_id)
        );
        return {
          ...item,
          SrNo: startindex + index + 1,
          resolved_roll_number: mapping?.roll_number || '—'
        };
      });

      this.items = res;
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async delete(item: any, index: any) {
    this.selected_item = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_item = item;
    this.confirmation_disabled_modal?.open();
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.bcs.update(this.selected_item.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async disable_country() {
    try {
      let res = await this.bcs.delete(this.selected_item.id);
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      this.selected_item = {};
      this.confirmation_delete_modal?.close()
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    try {
      let res: any
      for (let id of ids) {
        res = await this.bcs.delete(id);
      }
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async open_form_modal(item?: any) {
    this.selected_item = item || {};
    if (this.selected_item && this.selected_item.id) {
      let response = await this.bcs.get(item.id);
      this.selected_item = { ...response.data };
      this.form.reset();
      // Step 1: patch university
      this.form.patchValue({ university_id: this.selected_item.university_id, barcode: this.selected_item.barcode });
      // Step 2: patch academic_year (filtered by university)
      setTimeout(() => {
        this.form.patchValue({ academic_year_id: this.selected_item.academic_year_id });
        // Step 3: patch exam (filtered by academic_year)
        setTimeout(() => {
          this.form.patchValue({ exam_id: this.selected_item.exam_id });
          // Step 4: patch subject (filtered by exam)
          setTimeout(() => {
            this.form.patchValue({ subject_id: this.selected_item.subject_id });
            // Step 5: load filtered students then patch student
            this.ds.get_students_by_subject(this.selected_item.subject_id, this.selected_item.exam_id).then((list: any[]) => {
              this.filteredStudentList = list;
              setTimeout(() => {
                this.form.patchValue({ student_id: this.selected_item.student_id });
              });
            });
          });
        });
      });
    } else {
      this.selected_item = {};
      this.form.reset();
      this.filteredStudentList = [];
    }
    this.form_modal?.open();
  }
  get_roll_number(item: any): string {
    const student = (this.ds.dropdown_list?.student_list || []).find((s: any) => s.id == item?.student_id);
    const mapping = (student?.StudentMappings || []).find((m: any) =>
      m.exam_id == item?.exam_id && Array.isArray(m.subject_ids) && m.subject_ids.includes(+item?.subject_id)
    );
    return mapping?.roll_number || '';
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_item = item || {};
    this.view_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit_country() {
    try {
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_item && this.selected_item.id) {
        let update_response = await this.bcs.update(this.selected_item.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.bcs.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        barcode: String(item.barcode),
        is_active: true
      }));
      console.log(updatedData, 'dataa');

      await this.gs.bulk_form_submission(updatedData, this.bcs, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
}
